import { TimezoneApi } from '@api';
import { timezoneTypes as actionTypes } from './types';

export const fetchTimezones = (locale) => (dispatch) => {
  dispatch({
    type: actionTypes.LOADING,
  });

  TimezoneApi.getList({ locale })
    .then((response) => {
      dispatch({
        type: actionTypes.SUCCESS,
        payload: { [locale]: response },
      });
    })
    .catch((error) => {
      dispatch({
        type: actionTypes.FAILURE,
        message: `notify:general.errors.${error.status}`,
      });
    });
};
